import { useReactiveVar } from "@apollo/client";
import { useRouterState } from "@tanstack/react-router";
import { useEffect, useId } from "react";

import { datetimeToJS } from "@/helpers/parsers";
import { user as userStore } from "@/store";

export default function Intercom() {
  const scriptId = useId();

  const user = useReactiveVar(userStore);
  const asPath = useRouterState({ select: (s) => s.location.href });

  useEffect(() => {
    if (!window.Intercom) {
      return;
    }

    window.Intercom("boot", {
      api_base: "https://api-iam.intercom.io",
      app_id: process.env.INTERCOM_APP_ID,
      created_at: user
        ? Math.floor(datetimeToJS(user.dateJoined).getTime() / 1000)
        : undefined,
      email: user?.email,
      hide_default_launcher: true,
      is_public: user?.isPublic,
      name: user ? `${user?.firstName} ${user?.lastName}` : undefined,
      user_id: user?.id,
      username: user?.username,
    });
  }, [user]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: update intercom on route change
  useEffect(() => {
    if (!window.Intercom) {
      return;
    }

    window.Intercom("update");
  }, [asPath]);

  if (!process.env.INTERCOM_APP_ID) {
    return null;
  }

  return (
    <script
      // biome-ignore lint/security/noDangerouslySetInnerHtml: its fine
      dangerouslySetInnerHTML={{
        __html: `(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/jrbcowbz';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`,
      }}
      defer
      id={scriptId}
    />
  );
}
